// Angular
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'kt-quick-action',
	templateUrl: './quick-action.component.html',
})
export class QuickActionComponent implements OnInit, AfterViewInit {
	// Public properties
	
	// Set icon class name
	@Input() icon = 'flaticon2-gear';

	@Input() iconType: '' | 'warning';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() gridNavSkin: 'light' | 'dark' = 'light';
	permissions = localStorage.getItem('permissions');
	entityPreferences: any;
	displayNames: any = {};
	/**
	 * Component constructor
	 */
	constructor(private router:Router) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * After view init
	 */
	ngAfterViewInit(): void {
		this.loadDisplayNames();
	}

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.loadDisplayNames();
	}

	loadDisplayNames() {
		try {
			this.entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
			if (this.entityPreferences && this.entityPreferences.displayNames) {
				const advancedItem = this.entityPreferences.displayNames.find(item => item.value == 'advanced');
				this.displayNames = {
					advanced: advancedItem && advancedItem.name ? advancedItem.name : 'Advanced'
				};
			} else {
				this.displayNames = { advanced: 'Advanced' };
			}
		} catch (e) {
			this.displayNames = { advanced: 'Advanced' };
		}
	}
	redirect(route){
		this.router.navigate([route])
	  }

	onSVGInserted(svg) {
		svg.classList.add('kt-svg-icon', 'kt-svg-icon--success', 'kt-svg-icon--lg');
	}
	checkPermission(value){
		if(this.permissions.includes(value)){
		  return true;
		}else{
		  return false;
		}
	  }
}
